import React, { useState } from 'react';
import logo from '../images/logo.png';
import { Link } from 'react-scroll';

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <>
            <div className='bg-[#071633] fixed w-full z-50'>
                {/* Main Navbar container */}
                <div className='flex justify-between items-center py-6 px-6 md:px-24'>

                    {/* Logo */}
                    <div className='overflow-hidden'>
                        <img src={logo} className='w-24 md:w-32' alt='Logo' />
                    </div>

                    {/* Hamburger icon for mobile */}
                    <div className='md:hidden'>
                        <button onClick={toggleMenu} className='text-white focus:outline-none'>
                            <svg className='w-8 h-8' fill='none' stroke='currentColor' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
                                <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M4 6h16M4 12h16m-7 6h7'></path>
                            </svg>
                        </button>
                    </div>

                    {/* Navigation Menu for larger screens */}
                    <div className='hidden md:flex gap-16'>
                        {['home', 'about', 'project', 'amenities', 'contact'].map((item, index) => (
                            <Link 
                                key={index} 
                                to={item} 
                                smooth={true} 
                                duration={500} 
                                className='text-[#B79556] hover:text-white cursor-pointer'
                            >
                                <p className='capitalize text-xl'>{item}</p>
                            </Link>
                        ))}
                    </div>
                </div>

                {/* Mobile Menu */}
                {isOpen && (
                    <div className='md:hidden px-6 py-4 bg-[#071633]'>
                        {['home', 'about', 'project', 'amenities', 'contact'].map((item, index) => (
                            <Link 
                                key={index} 
                                to={item} 
                                smooth={true} 
                                duration={500} 
                                className='text-[#B79556] hover:text-white cursor-pointer py-2'
                            >
                                <p className='capitalize text-xl'>{item}</p>
                            </Link>
                        ))}
                    </div>
                )}
            </div>
        </>
    );
}
